import { render } from "./CustomerLayout.vue?vue&type=template&id=5aac3d75"
import script from "./CustomerLayout.vue?vue&type=script&lang=js"
export * from "./CustomerLayout.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__